import ProjectNotificationCompanySettingsPage from './ProjectNotificationCompanySettings.vue'

/** 全体通知設定画面のルーター互換ラッパー。 */
export default ProjectNotificationCompanySettingsPage
